import './style.scss';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import Comments from './comments';
import comparisonTable from './comparisonTable';
import { CommentProvider, useComment } from './providers';
const CommentsPanel = (props) => {
    const { comparisonDetail, onHide } = props;
    const [isCollapsed, setIsCollapsed] = useState(false);
    const { comments, getComments, isLoadingComments } = useComment();
    const sidebarClass = classnames('comment-panel', {
        collapsed: isCollapsed,
    });
    useEffect(() => {
        getComments(comparisonDetail.documentComparisonId);
    }, [comparisonDetail, getComments]);
    return (React.createElement("div", { className: sidebarClass },
        React.createElement("span", { className: 'close-action', onClick: () => { setIsCollapsed(!isCollapsed); onHide(); } },
            React.createElement("i", { className: "fa-solid fa-xmark" })),
        React.createElement("div", { className: 'heading' },
            React.createElement("span", null,
                "Comparison documents (",
                comparisonDetail.documents.length,
                ")")),
        comparisonTable(comparisonDetail),
        React.createElement("div", { className: 'comment-box' },
            React.createElement(Comments, { isLoading: isLoadingComments, comments: comments, documentComparisonId: comparisonDetail.documentComparisonId }))));
};
const CommentsPanelWrapper = (props) => (React.createElement(CommentProvider, null,
    React.createElement(CommentsPanel, Object.assign({}, props))));
export default CommentsPanelWrapper;
